import { URLS } from '../../../constants';
import apiClient from '../../client';
const getMasteryCriteriaTemplateAPI = {
    getMasteryCriteriaTemplate: ({
        templateId,
        dataType,
        isProgram,
        temporaryId,
        addNew,
        isTarget,
        programId,
        targetId,
        dropdownSelected,
        previousTemplateId,
        newProgramTargetTempId,
    }: {
        templateId: any;
        dataType: any;
        isProgram: any;
        temporaryId: any;
        addNew: any;
        isTarget: any;
        programId: any;
        targetId: any;
        dropdownSelected?: any;
        previousTemplateId?: any;
        newProgramTargetTempId?: any;
    }) =>
        apiClient.post(URLS.getMasteryCriteriaTemplate, {
            data: {
                templateId,
                dataType,
                isProgram,
                temporaryId,
                addNew,
                isTarget,
                programId,
                targetId,
                dropdownSelected,
                previousTemplateId,
                newProgramTargetTempId,
            },
        }),
};
export default getMasteryCriteriaTemplateAPI;
